import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const pains = [{
  title: '"Hola, cómo va" y silencio',
  desc: 'Abrís con lo que se te ocurre, ella responde con monosílabos y en dos minutos el chat ya murió sin que sepas por qué.'
}, {
  title: 'El chat arranca bien y se enfría solo',
  desc: 'Había onda, respuestas rápidas, humor. Y de golpe, nada. El chat se congela sin razón aparente y vos sin saber cómo rescatarlo.'
}, {
  title: 'No sabés cuándo ni cómo invitar',
  desc: 'Siempre esperás el "momento perfecto" que nunca llega. O avanzás demasiado pronto y la enfriás. O esperás demasiado y el interés muere.'
}, {
  title: 'Siempre aparece alguna excusa',
  desc: '"Estoy ocupada esta semana." "Te aviso." Esas respuestas no son coincidencia: son el resultado de un chat que no generó suficiente interés antes del cierre.'
}, {
  title: 'Quedás en visto sin entender qué pasó',
  desc: 'Repasás el hilo buscando el mensaje que rompió todo y no encontrás nada obvio. El problema casi nunca está en un mensaje: está en el patrón completo.'
}, {
  title: 'Parecés necesitado sin darte cuenta',
  desc: 'Doble mensaje, triple mensaje, el "¿viste mi mensaje?". Cada acción de más destruye tu valor percibido en tiempo real sin que lo notes.'
}];
export function PainPoints() {
  return <section aria-label="Problemas" className="bg-ink-2 border-y border-white/5" data-id="element-108" data-mp="23soly0vnto3w">
      <div className="mx-auto max-w-4xl px-5 py-20 pt-[5px] pb-[0px]" data-id="element-109" data-mp="1g11408gdlndr">
        <h2 className="text-center font-display font-black text-white sm:text-4xl pt-[24px] text-[25px]" data-id="element-110" data-mp="1b2pvc11thix4">
          😤 ¿Cuántas citas más vas a dejar pasar así?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-white/70" data-id="element-111" data-mp="1p0ecaxsrk5ww">
          Sabés chatear. Sos inteligente. No sos aburrido. Pero algo falla entre el primer mensaje y
          la cita. Y lo más frustrante es que no entendés exactamente dónde.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-azul-soft" data-id="element-112" data-mp="2vibah40o5yxq">
          No es falta de personalidad. No es falta de ganas. Es falta de un sistema.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-113" data-mp="1y2opratd5eph">
          {pains.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="flex gap-3 rounded-xl border border-white/10 bg-ink p-5 pb-[39px]" data-id="element-114" data-mp="226whlgv4barx" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-azul/20 text-azul-soft" data-id="element-115" data-mp="1edwe3fmiuc9u">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-116" data-mp="1o6ln83ulne20" />
              </span>
              <div data-id="element-117" data-mp="qqoad24qrb9x">
                <h3 className="text-sm font-bold text-white" data-id="element-118" data-mp="qr7u8odyc9ql">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60" data-id="element-119" data-mp="vprfemkq1hhw">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-120" data-mp="o573sxyf4j3u">
          <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-121" data-mp="o3vzmx1299c7">
            ¿Y si la próxima vez que haya onda supieras exactamente qué hacer con ella?
          </p>
          <p className="mt-3 text-lg font-semibold text-gold" data-id="element-122" data-mp="e69737qu9j9r">
            La próxima cita empieza en el próximo mensaje.
          </p>
        </div>
      </div>
    </section>;
}